import React from "react";
import { useNavigate } from "react-router-dom";

import LatheImg from "../assets/lathe.jpg";
import GearBoxImg from "../assets/gearbox.jpg";
import ElectricalCabinetImg from "../assets/electrical_cabinet.jpg";
import SurfaceGrinderImg from "../assets/surface_grinder.jpg";
import PillarDrillImg from "../assets/pillar_drill.jpg";
import GearCouplingImg from "../assets/gear_coupling.jpg";

function HomePage() {
    const navigate = useNavigate();

    return (
        <div className="font-sans w-full overflow-x-hidden min-h-screen text-gray-800">

            {/* HERO */}
            <header
                className="relative mt-16 bg-cover bg-center text-white"
                style={{ backgroundImage: `url(${LatheImg})` }}
            >
                <div className="absolute inset-0 bg-black/70" />

                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28 text-center">
                    <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold leading-tight mb-6">
                        Reliable Machine Repair Services
                    </h1>

                    <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto">
                        Minimising downtime. Maximising performance.
                    </p>

                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        {/* Primary CTA */}
                        <button
                            onClick={() => navigate("/breakdown")}
                            className="bg-blue-600 hover:bg-blue-700 transition text-white px-8 py-3 rounded-lg font-semibold shadow-md"
                        >
                            Report a Breakdown
                        </button>

                        {/* Secondary CTA */}
                        <button
                            onClick={() => navigate("/contact")}
                            className="border border-white/70 hover:bg-white hover:text-gray-900 transition px-8 py-3 rounded-lg font-semibold"
                        >
                            Request a Quote
                        </button>
                    </div>
                </div>
            </header>

            {/* SERVICES */}
            <section className="py-16 sm:py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6">
                    <h2 className="text-2xl sm:text-3xl font-bold text-center mb-12">
                        Our Services
                    </h2>

                    <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
                        {[
                            {
                                title: "Preventive Maintenance",
                                desc: "Scheduled inspections to prevent costly downtime.",
                            },
                            {
                                title: "Emergency Repairs",
                                desc: "Rapid response to get you back up and running.",
                            },
                            {
                                title: "Servicing",
                                desc: "Full servicing for optimal machine performance.",
                            },
                            {
                                title: "Diagnostics",
                                desc: "Accurate fault finding using modern techniques.",
                            },
                            {
                                title: "Retrofitting",
                                desc: "Upgrade older machines with modern systems.",
                            },
                            {
                                title: "Modifications",
                                desc: "Custom solutions tailored to your needs.",
                            },
                        ].map((service, i) => (
                            <div
                                key={i}
                                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition duration-300 text-left border border-gray-100"
                            >
                                <h3 className="text-lg font-semibold mb-3">
                                    {service.title}
                                </h3>
                                <p className="text-gray-600 text-sm leading-relaxed">
                                    {service.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ABOUT */}
            <section className="py-16 sm:py-20">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
                    <h2 className="text-2xl sm:text-3xl font-bold mb-6">
                        About Us
                    </h2>

                    <p className="text-base sm:text-lg leading-relaxed text-gray-600">
                        Machine Repairs Limited provides professional repair,
                        servicing, and maintenance solutions for industrial
                        equipment. With years of hands-on experience, we help
                        businesses reduce downtime and maintain reliable operations.
                        <br /><br />
                        From routine servicing to urgent breakdown support, we deliver
                        dependable results when it matters most.
                    </p>
                </div>
            </section>

            {/* GALLERY */}
            <section className="py-16 sm:py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6">
                    <h2 className="text-2xl sm:text-3xl font-bold text-center mb-12">
                        Our Work
                    </h2>

                    <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
                        {[LatheImg, GearBoxImg, ElectricalCabinetImg, SurfaceGrinderImg, PillarDrillImg, GearCouplingImg].map((img, i) => (
                            <div
                                key={i}
                                className="group overflow-hidden rounded-xl shadow-sm hover:shadow-lg transition"
                            >
                                <img
                                    src={img}
                                    alt={`Machine repair work ${i + 1}`}
                                    className="w-full h-48 object-cover group-hover:scale-110 transition duration-500"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

        </div>
    );
}

export default HomePage;